import { useEffect, useState, useRef } from "react";
import axios from "axios";
import "./wallet.css";
import { NoBackpackSharp } from "@mui/icons-material";
import { MdSend } from "react-icons/md";
import { test_ip } from "../services/constants";
import { FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";
import { setError } from "../services/actions";
import { useDispatch } from "react-redux";

const Wallet = () => {
  const [walletHistory, setWalletHistory] = useState([]);
  const [transfer, setTransfer] = useState(false);
  const phone = useRef();
  const amount = useRef();
  const password = useRef();
  const diapach = useDispatch();

  useEffect(() => {
    var user = JSON.parse(localStorage.getItem("user"));
    var data = {
      id: user.user_id,
      server_token: user.server_token,
      type: 7,
    };
    Get_Wallet_History(data);
  }, []);

  const Get_Wallet_History = function (data) {
    // Wallet Page on profile Tab
    var body = data;
    body = JSON.stringify(body);
    axios
      .post(`${test_ip}api/admin/get_wallet_history`, body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data);
          if (res.data.success == true) {
            // you would get something like this
            //wallet_history = res.data.wallet_history // with full wallet data
            console.log(res.data.wallet_history);
            setWalletHistory(res.data.wallet_history);
            console.log(walletHistory);
          } else {
            console.log(res.data.error_code);
            if (res.data.error_code == 999) {
              console.log(true);
              toast.error("Please Login !", {
                position: toast.POSITION.TOP_RIGHT,
              });
              localStorage.clear();
              window.location.reload();
              console.log("sdfgh");
            } else {
              diapach(
                setError({
                  error: true,
                  message: `failed, please check again(${res.data.error_code})`,
                })
              );
            }
          }
        } else {
          // do something
          console.log("erororor", res.data.error_code);
          if (res.data.error_code == 999) {
            console.log(true);
            toast.error("Please Login !", {
              position: toast.POSITION.TOP_RIGHT,
            });
            localStorage.clear();
            window.location.reload();
            console.log("sdfgh");
          } else {
            diapach(
              setError({
                error: true,
                message: `failed, please check again(${res.data.error_code})`,
              })
            );
          }
        }
      })
      .catch((err) => {
        // do something
        diapach(setError({ error: true, message: "failed,please reload" }));
      });
  };

  const Transfer_Wallet_History = function (data) {
    // Transfer Wallet feature on Wallate Page
    var body = data;
    body = JSON.stringify(body);
    axios
      .post(`${test_ip}api/user/transfer_wallet_amount`, body, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.status === 200) {
          console.log(res.data);
          if (res.data.success == true) {
            // you would get something here
            alert("Sent Successfully");
            window.location.reload(false);
          } else {
            console.log(res.data.error_code);
            if (res.data.error_code == 999) {
              console.log(true);
              toast.error("Please Login !", {
                position: toast.POSITION.TOP_RIGHT,
              });
              localStorage.clear();
              window.location.reload();
              console.log("sdfgh");
            } else {
              diapach(
                setError({
                  error: true,
                  message: `failed, please check again(${res.data.error_code})`,
                })
              );
            }
          }
        } else {
          // do something
          console.log("erororor", res.data.error_code);
          if (res.data.error_code == 999) {
            console.log(true);
            toast.error("Please Login !", {
              position: toast.POSITION.TOP_RIGHT,
            });
            localStorage.clear();
            window.location.reload();
            console.log("sdfgh");
          } else {
            diapach(
              setError({
                error: true,
                message: `failed, please check again(${res.data.error_code})`,
              })
            );
          }
        }
      })
      .catch((err) => {
        // do something
        diapach(setError({ error: true, message: "failed,please reload" }));
      });
  };

  const handleTransaction = (e) => {
    e.preventDefault();
    var user = JSON.parse(localStorage.getItem("user"));
    var data = {
      user_id: user.user_id,
      top_up_user_phone: phone.current.value ? phone.current.value : "",
      password: password.current.value ? password.current.value : "",
      wallet: amount.current.value ? amount.current.value : "",
      server_token: user.server_token,
    };
    Transfer_Wallet_History(data);
    phone.current.value = "";
    password.current.value = "";
    amount.current.value = "";
  };

  return (
    <div className="b-wallet-page">
      <div className="b-current-bal">
        Current Balance&nbsp;
        <p>
          {walletHistory.length !== 0
            ? [
                <p>
                  <span>{walletHistory[0].from_currency_code}</span>
                  {walletHistory[0].total_wallet_amount}
                </p>,
              ]
            : ["ETB 0.00"]}
        </p>
      </div>
      <br />
      <div className="b-transfer-btn">
        <button
          onClick={() => {
            setTransfer(!transfer);
          }}
        >
          <p>
            <MdSend />
          </p>
          <p>
            Transfer <br /> <span className="b-send-fund">Send fund</span>
          </p>
        </button>
      </div>
      {transfer ? (
        <div className="b-main">
          <div className="b-popup">
            <div>
              <button
                style={{
                  float: "right",
                }}
                onClick={() => setTransfer(false)}
              >
                <FaTimes fill="#f12235" size="20px" />
              </button>
            </div>
            <div>
              <form>
                <h3>Transfer</h3>
                <input
                  type="text"
                  placeholder="Recievers phone number"
                  ref={phone}
                />
                <br />
                <input type="text" placeholder="amount" ref={amount} />
                <br />
                <input type="text" placeholder="Password" ref={password} />
                <br />
                <button
                  onClick={(e) => {
                    handleTransaction(e);
                    setTransfer(false);
                  }}
                >
                  Send
                </button>
              </form>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      <p className="b-transaction">Transactions</p>
      {walletHistory &&
        walletHistory.map((wh) => {
          return [
            <div className="b-tran">
              <div className="b-discription">
                <h3>{wh.wallet_description}</h3>
                <p>{wh.updated_at}</p>
              </div>
              <p>
                {wh.wallet_status === 1 ? "+" : "-"}{" "}
                {walletHistory && walletHistory[0].from_currency_code}{" "}
                <p
                  style={{
                    display: "inline-block",
                    margin: "0",
                    color: wh.wallet_status === 1 ? "green" : "red",
                    fontWeight: "bold",
                    fontSize: "1rem",
                  }}
                >
                  {wh.added_wallet}
                </p>
              </p>
            </div>,
          ];
        })}
    </div>
  );
};

export default Wallet;
